<style scoped lang="scss">
a.card-link {
	text-decoration: none;
}
</style>
<template>
	<div class="row">
		<div class="col-md-4">
			<RouterLink class="card-link" to="/_/review/contact">
				<div class="card" style="width: 100%">
					<img
						alt="mailer"
						class="card-img-top"
						src="/static/img/contact.png"
					/>
					<div class="card-body">
						<h1>Contacts</h1>
						<p>Mailing addresses, email addresses, and phone numbers</p>
					</div>
				</div>
			</RouterLink>
		</div>
		<div class="col-md-4">
			<RouterLink class="card-link" to="/_/review/mailer">
				<div class="card" style="width: 100%">
					<img alt="mailer" class="card-img-top" src="/static/img/mailer.jpg" />
					<div class="card-body">
						<h1>Mailers</h1>
						<p>Letters that have been sent to the public</p>
					</div>
				</div>
			</RouterLink>
		</div>
		<div class="col-md-4">
			<RouterLink class="card-link" to="/_/review/pool">
				<div class="card" style="width: 100%">
					<img
						alt="overhead pool"
						class="card-img-top"
						src="/static/img/pool-overhead.jpg"
					/>
					<div class="card-body">
						<h1>Imported Pools</h1>
						<p>
							Pools that have been imported with their aerial imagery appear
							here waiting for human review before being added to the system
						</p>
					</div>
				</div>
			</RouterLink>
		</div>
		<div class="col-md-4">
			<RouterLink class="card-link" to="/_/review/note">
				<div class="card" style="width: 100%">
					<img
						alt="notes"
						class="card-img-top"
						src="/static/img/field-dictation.png"
					/>
					<div class="card-body">
						<h1>Notes</h1>
						<p>
							Field notes uploaded by the Nidus Notes iOS app — the raw audio
							and its transcript, the structured records and knowledge graph
							extracted on the device, the location track, and the photos taken
							during the recording.
						</p>
					</div>
				</div>
			</RouterLink>
		</div>
		<div class="col-md-4">
			<RouterLink class="card-link" to="/_/review/site">
				<div class="card" style="width: 100%">
					<img
						alt="pool"
						class="card-img-top"
						src="/static/img/insecticide-application.jpg"
					/>
					<div class="card-body">
						<h1>Sites</h1>
						<p>
							Areas that we're tracking for potentially becoming breeding
							locations.
						</p>
					</div>
				</div>
			</RouterLink>
		</div>
		<div class="col-md-4">
			<RouterLink class="card-link" to="/_/review/inspection">
				<div class="card" style="width: 100%">
					<img
						alt="inspections"
						class="card-img-top"
						src="/static/img/inspection-placeholder.svg"
					/>
					<div class="card-body">
						<h1>Inspections</h1>
						<p>
							Field inspections recorded against features, with their method,
							stage, and larval density.
						</p>
					</div>
				</div>
			</RouterLink>
		</div>
		<div class="col-md-4">
			<RouterLink class="card-link" to="/_/review/treatment">
				<div class="card" style="width: 100%">
					<img
						alt="treatments"
						class="card-img-top"
						src="/static/img/treatment-placeholder.svg"
					/>
					<div class="card-body">
						<h1>Treatments</h1>
						<p>
							Pesticide and physical-control applications recorded against
							features.
						</p>
					</div>
				</div>
			</RouterLink>
		</div>
		<div v-if="hasMapvision" class="col-md-4">
			<RouterLink class="card-link" to="/_/review/mapvision">
				<div class="card" style="width: 100%">
					<img
						alt="mapvision"
						class="card-img-top"
						src="/static/img/mapvision-logo.png"
					/>
					<div class="card-body">
						<h1>MapVision</h1>
						<p>
							MapVision data synchronized from your organization's MapVision
							install.
						</p>
					</div>
				</div>
			</RouterLink>
		</div>
		<div class="col-md-4">
			<RouterLink class="card-link" to="/_/review/map">
				<div class="card" style="width: 100%">
					<img
						alt="map"
						class="card-img-top"
						src="/static/img/map-placeholder.svg"
					/>
					<div class="card-body">
						<h1>Map</h1>
						<p>
							The district's Sites, Features, Treatments, and Observations on
							one map, with the ledger tables beneath it.
						</p>
					</div>
				</div>
			</RouterLink>
		</div>
	</div>
</template>

<style>
.card-link .card-img-top {
	height: 200px;
	object-fit: cover;
	object-position: center;
}

.card-link .card {
	height: 100%;
}

.card-link {
	text-decoration: none;
	color: inherit;
	display: block;
	height: 100%;
}
</style>

<script setup lang="ts">
import { computed } from "vue";
import { useSessionStore } from "@/store/session";

const sessionStore = useSessionStore();
const hasMapvision = computed(() =>
	(sessionStore.organization?.integrations ?? []).includes("mapvision"),
);
</script>
